
import React, { useState, useEffect } from 'react';
import {
  Users, TrendingUp,
  CheckCircle, ArrowRight, Lock,
  Play, Shield, BarChart3, User, Bell, DollarSign, ArrowLeftRight, Building,
  FileText, Star, Zap, Clock, SlidersHorizontal, FileBarChart, PlugZap, UserCog, Antenna, ShieldCheck
} from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
const PaymentSolutionsLanding = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activePanel, setActivePanel] = useState('merchant');
  const [visibleItems, setVisibleItems] = useState(new Set());
  const [scrollY, setScrollY] = useState(0);


  useEffect(() => {
    setIsVisible(true);
  }, []);

  const [imageLoaded, setImageLoaded] = useState(false);




  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    const timer = setTimeout(() => {
      const interval = setInterval(() => {
        setVisibleItems(prev => {
          const newSet = new Set(prev);
          const itemCount = activePanel === 'merchant' ? 4 : 4;
          if (newSet.size < itemCount) {
            newSet.add(newSet.size);
          }
          return newSet;
        });
      }, 300);

      return () => clearInterval(interval);
    }, 500);

    return () => clearTimeout(timer);
  }, [activePanel]);

  useEffect(() => {
    setVisibleItems(new Set());
  }, [activePanel]);

  const merchant = [
    {
      icon: <Antenna className="w-7 h-7" />, // Replace with an appropriate icon if needed
      title: "Multi-Channel Support",
      desc: "PG, POS, QR, NETC & beyond — all channels covered seamlessly.",
      color: "blue"
    },
    {
      icon: <ShieldCheck className="w-7 h-7" />, // Compliance icon
      title: "Compliance Ready",
      desc: "eKYC + audit logs for regulator checks & governance.",
      color: "red"
    },
    {
      icon: <BarChart3 className="w-7 h-7" />, // Scalable
      title: "Scalable",
      desc: "Handles millions of merchants for banks, PSPs & aggregators.",
      color: "green"
    },
    {
      icon: <Zap className="w-7 h-7" />, // Faster activation
      title: "Faster Activation",
      desc: "Reduce merchant onboarding from weeks to minutes.",
      color: "yellow"
    }
  ];


  const features = [
    {
      icon: <UserCog className="w-7 h-7" />,
      title: "User & Role Management",
      desc: "Role-based access, maker-checker for sensitive actions, and audit logs for compliance.",
      color: "blue"
    },
    {
      icon: <FileBarChart className="w-7 h-7" />,
      title: "MIS & Reporting",
      desc: "Merchant funnel analytics, risk dashboards, and sales performance tracking.",
      color: "indigo"
    },
    {
      icon: <PlugZap className="w-7 h-7" />,
      title: "Integration Ready",
      desc: "APIs for banks & PSPs. Plug-and-play for PGs, POS, and white-label onboarding support.",
      color: "purple"
    }
  ];

  const merchantFeatures = [
    {
      icon: <User className="w-6 h-6" />,
      title: "KYC Management",
      description: "Submit KYC documents along with Vieo KYC & track onboarding status",
      color: "from-blue-500 to-cyan-500"
    },
    {
      icon: <FileText className="w-6 h-6" />,
      title: "Document Center",
      description: "Download agreements, invoices & settlement info",
      color: "from-purple-500 to-pink-500"
    },
    {
      icon: <Bell className="w-6 h-6" />,
      title: "Smart Alerts",
      description: "Alerts for compliance renewals or pending docs",
      color: "from-orange-500 to-red-500"
    },
    {
      icon: <Lock className="w-6 h-6" />,
      title: "Secure Communication",
      description: "Direct communication with risk & compliance teams",
      color: "from-green-500 to-emerald-500"
    }
  ];

  const resellerFeatures = [
    {
      icon: <Users className="w-6 h-6" />,
      title: "Multi-Merchant Management",
      description: "Onboard & manage multiple merchants across PG/POS/QR",
      color: "from-indigo-500 to-blue-500"
    },
    {
      icon: <BarChart3 className="w-6 h-6" />,
      title: "Performance Analytics",
      description: "Track merchant performance & volume trends",
      color: "from-teal-500 to-cyan-500"
    },
    {
      icon: <DollarSign className="w-6 h-6" />,
      title: "Commission Tracking",
      description: "Commission & incentive tracking with real-time updates",
      color: "from-yellow-500 to-orange-500"
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: "White-Label Solutions",
      description: "Custom onboarding with partner branding",
      color: "from-pink-500 to-rose-500"
    }
  ];

  const currentFeatures = activePanel === 'merchant' ? merchantFeatures : resellerFeatures;






  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header Section */}
      <Header />  {/* SECTION 1: DARK - Hero Section */}

      <section
        className="py-12 px-4 sm:px-6 lg:px-8 bg-slate-50"
        style={{
          background: `linear-gradient(135deg, 
          rgba(59, 130, 246, 0.1) 0%, 
          rgba(147, 51, 234, 0.1) 50%, 
          rgba(219, 39, 119, 0.1) 100%
        )`,
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div
            className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-br from-blue-200/30 to-purple-200/30 rounded-full animate-pulse transform rotate-45"
            style={{ transform: `translateY(${scrollY * 0.1}px) rotate(45deg)` }}
          ></div>
          <div
            className="absolute top-40 right-20 w-24 h-24 bg-gradient-to-br from-indigo-200/40 to-blue-200/40 rounded-lg animate-bounce transform rotate-12"
            style={{ animationDelay: '1s', transform: `translateY(${scrollY * 0.15}px) rotate(12deg)` }}
          ></div>
          <div
            className="absolute bottom-20 left-20 w-16 h-16 bg-gradient-to-br from-purple-200/30 to-pink-200/30 rounded-full animate-pulse transform -rotate-12"
            style={{ animationDelay: '2s', transform: `translateY(${scrollY * 0.2}px) rotate(-12deg)` }}
          ></div>
          <div
            className="absolute bottom-40 right-10 w-20 h-20 bg-gradient-to-br from-cyan-200/40 to-blue-200/40 rounded-lg animate-bounce transform rotate-45"
            style={{ animationDelay: '0.5s', transform: `translateY(${scrollY * 0.12}px) rotate(45deg)` }}
          ></div>
        </div>
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <div className="space-y-4">
                {/* <div className="flex justify-start">
                  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-medium shadow-lg">
                    <Star className="w-4 h-4" />
                    <div className="text-center leading-tight">
                      Onboard Merchants in Minutes, Across Any Channel
                    </div>
                  </div>
                </div> */}

                <div className="flex justify-start">
                  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-1.5 rounded-full text-xs sm:text-sm font-medium shadow-md max-w-full">
                    <Star className="w-3 h-3 flex-shrink-0" aria-hidden="true" />
                    <p className="whitespace-normal leading-tight">
                      Onboard Merchants in Minutes, Across Any Channel.
                    </p>
                  </div>
                </div>

                {/* <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight tracking-tight">
                  <div className="text-slate-800 font-bold mb-2">
                    Merchant Onboarding Solution
                  </div>
                  <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent font-semibold leading-snug">
                    Onboard Merchants in Minutes,<br />
                    Across Any Channel
                  </div>
                </h1> */}

                <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight tracking-tight">
                  <div className="text-gray-800 font-semibold">
                    MERCHANT MANAGEMENT
                  </div>
                  <div className="text-lg sm:text-xl lg:text-1.5xl font-medium bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent mt-1">
                    Onboard Merchants in Minutes, Across Any Channel                  </div>
                </h1>

                <p className="text-base text-slate-600 leading-relaxed font-normal">
                  Whether it’s Payment Gateway, POS Terminals, QR, or NETC FASTag issuance, our Merchant Onboarding Solution is designed to streamline the entire lifecycle — from digital KYC to risk assessment, activation to compliance management. One platform, multiple channels, unlimited scalability.                </p>

                {/* Key Features */}
                {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4">
                  <div className="flex items-center gap-2">
                    <CheckCircle className="w-5 h-5 text-green-600" />
                    <span className="text-sm text-slate-700 font-medium">Digital KYC</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Shield className="w-5 h-5 text-blue-600" />
                    <span className="text-sm text-slate-700 font-medium">Risk Assessment</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Clock className="w-5 h-5 text-purple-600" />
                    <span className="text-sm text-slate-700 font-medium">Quick Activation</span>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Right Content - Video Placeholder */}
            <div className="relative">
              <div className="relative rounded-xl overflow-hidden shadow-2xl bg-black/20 backdrop-blur-sm border border-white/10">
                <video
                  className="w-full h-auto rounded-xl"
                  autoPlay
                  muted
                  loop
                  playsInline
                  src="./recon1.mp4"
                  preload="metadata"
                >
                  <source src="/path/to/your/video.mp4" type="video/mp4" />
                  <source src="/path/to/your/video.webm" type="video/webm" />
                  Your browser does not support the video tag.
                </video>

                {/* Optional overlay for styling */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none rounded-xl"></div>
              </div>

              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-20 h-20 bg-purple-400/30 rounded-full blur-xl"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-blue-400/30 rounded-full blur-lg"></div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 bg-slate-50 px-4 sm:px-6 lg:px-8" >
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-4">
            <h2 className="block bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 animate-pulse hover:animate-none transition-all duration-500 hover:scale-105 cursor-default">
              {/* Complete Payment Gateway */}
              CORE FEATURES

            </h2>

          </div>
          {/* Image Container */}
          <div className="relative group w-full">
            <div className="relative bg-white rounded-xl overflow-hidden transition-all duration-300">
              <img
                src="/coreFea.png" // Replace with your image path
                alt="Payment Gateway Platform Screenshot"
                className={`w-full h-auto max-h-100 object-cover transition-all duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'
                  }`}
                onLoad={() => setImageLoaded(true)}
              />
            </div>
            {/* Decorative Elements */}
            <div className="absolute -top-3 -right-3 w-16 h-16 bg-gradient-to-br from-slate-400/15 to-slate-500/15 rounded-full blur-lg"></div>
            <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-gradient-to-br from-slate-500/15 to-slate-600/15 rounded-full blur-lg"></div>
          </div>
        </div>
      </section>

      {/* <section className="py-8 px-4 sm:px-6 lg:px-8 bg-slate-50">
        <div className="max-w-5xl mx-auto">
          <div className="relative group">
            <img
              src="/platform.png"
              alt="Payment Gateway Platform Screenshot"
              className={`w-full h-auto rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
              onLoad={() => setImageLoaded(true)}
            />
            <div className="absolute -top-3 -right-3 w-16 h-16 bg-gradient-to-br from-slate-400/15 to-slate-500/15 rounded-full blur-lg"></div>
            <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-gradient-to-br from-slate-500/15 to-slate-600/15 rounded-full blur-lg"></div>
          </div>
        </div>
      </section> */}

      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-50 via-white to-slate-100 relative overflow-hidden">
        {/* Animated Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-400/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-cyan-400/10 rounded-full blur-3xl animate-pulse delay-2000"></div>
        </div>

        <div className="max-w-7xl mx-auto relative">
          {/* Header */}
          <div className="text-center mb-8">


            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up">
              <span className="inline-block animate-pulse bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-600 bg-clip-text text-transparent">
                SELF SERVICE DASHBOARDS
              </span>{" "}
              {/* <span className="inline-block animate-bounce-slow">

                            Payment Gateway Suite?
                        </span> */}
            </h2>
            {/* <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Empowering merchants and partners with intuitive, feature-rich dashboards for seamless business management
            </p> */}
          </div>

          {/* Panel Toggle */}
          <div className="flex justify-center px-4 mb-10">
            <div className="flex flex-col sm:flex-row items-center w-full max-w-md bg-gray-100 p-1 rounded-full shadow-md gap-2 sm:gap-0">

              <button
                onClick={() => setActivePanel('merchant')}
                className={`flex-1 flex items-center justify-center px-4 py-2 text-sm sm:text-base font-medium rounded-full transition-all duration-300 antialiased ${activePanel === 'merchant'
                  ? 'bg-gradient-to-r from-blue-500 to-cyan-500 text-white shadow-md'
                  : 'bg-white text-gray-700 hover:text-gray-900'
                  }`}
              >
                Merchant Panel
              </button>

              <button
                onClick={() => setActivePanel('reseller')}
                className={`flex-1 flex items-center justify-center px-4 py-2 text-sm sm:text-base font-medium rounded-full transition-all duration-300 antialiased ${activePanel === 'reseller'
                  ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-md'
                  : 'bg-white text-gray-700 hover:text-gray-900'
                  }`}
              >
                Reseller Panel
              </button>

            </div>
          </div>



          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {currentFeatures.map((feature, index) => (
              <div
                key={index}
                className={`group relative transition-all duration-700 transform ${visibleItems.has(index)
                  ? 'translate-y-0 opacity-100'
                  : 'translate-y-8 opacity-0'
                  }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent rounded-xl p-[1px] group-hover:from-blue-400/30 group-hover:via-purple-400/30 group-hover:to-cyan-400/30 transition-all duration-300">
                    <div className="h-full bg-white/90 backdrop-blur-sm rounded-xl"></div>
                  </div>

                  <div className="relative p-6 flex flex-col items-center text-center group-hover:transform group-hover:scale-[1.01] transition-all duration-300">
                    <div className={`flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br ${feature.color} flex items-center justify-center text-white shadow-lg group-hover:shadow-xl transform group-hover:rotate-3 transition-all duration-300`}>
                      {React.cloneElement(feature.icon, { className: "w-5 h-5" })}
                    </div>

                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors duration-300">
                        {feature.title}
                      </h3>
                      <p className="text-sm text-gray-600 leading-relaxed group-hover:text-gray-700 transition-colors duration-300">
                        {feature.description}
                      </p>
                    </div>
                  </div>

                  <div className={`absolute inset-0 rounded-xl bg-gradient-to-br ${feature.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300 pointer-events-none`}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="py-16 px-4 bg-slate-50">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up">
            <span className="inline-block animate-pulse bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-600 bg-clip-text text-transparent">
              ADVANCED CAPABILITIES
            </span>{" "}
            {/* <span className="inline-block animate-bounce-slow">

                            Payment Gateway Suite?
                        </span> */}
          </h2>

          <style jsx>{`
                    @keyframes fade-in-up {
                        0% {
                            opacity: 0;
                            transform: translateY(20px);
                        }
                        100% {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    @keyframes bounce-slow {
                        0%, 20%, 50%, 80%, 100% {
                            transform: translateY(0);
                        }
                        40% {
                            transform: translateY(-3px);
                        }
                        60% {
                            transform: translateY(-1px);
                        }
                    }

                    .animate-fade-in-up {
                        animation: fade-in-up 1s ease-out;
                    }

                    .animate-bounce-slow {
                        animation: bounce-slow 2s infinite;
                        animation-delay: 0.5s;
                    }
                `}</style>

          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {features.map((feature, index) => (
              <div
                key={index}
                className="p-6 bg-white border border-gray-200 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col items-center text-center group hover:scale-[1.02] transition-transform"
              >
                <div className={`mb-4 p-4 rounded-full bg-${feature.color}-100 text-${feature.color}-600`}>
                  {feature.icon}
                </div>
                <h3 className="text-base font-semibold text-slate-800 mb-2">{feature.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>

        </div>
      </div>

      <div className="py-16 px-4 bg-slate-50">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up">
            <span className="inline-block animate-pulse bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-600 bg-clip-text text-transparent">
              Why Choose Our
            </span>{" "}
            <span className="inline-block animate-bounce-slow">

              Merchant Onboarding Solution?
            </span>
          </h2>

          <style jsx>{`
                    @keyframes fade-in-up {
                        0% {
                            opacity: 0;
                            transform: translateY(20px);
                        }
                        100% {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    @keyframes bounce-slow {
                        0%, 20%, 50%, 80%, 100% {
                            transform: translateY(0);
                        }
                        40% {
                            transform: translateY(-3px);
                        }
                        60% {
                            transform: translateY(-1px);
                        }
                    }

                    .animate-fade-in-up {
                        animation: fade-in-up 1s ease-out;
                    }

                    .animate-bounce-slow {
                        animation: bounce-slow 2s infinite;
                        animation-delay: 0.5s;
                    }
                `}</style>

          <div className="grid md:grid-cols-4 gap-6 mt-12">
            {merchant.map((feature, index) => (
              <div key={index} className="text-center group hover:transform hover:scale-105 transition-all duration-300">
                <div className={`w-16 h-16 bg-${feature.color}-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:shadow-lg transition-shadow duration-300`}>
                  <div className={`text-${feature.color}-600`}>
                    {feature.icon}
                  </div>
                </div>
                <h3 className="font-semibold text-slate-900 mb-2 text-sm md:text-base">{feature.title}</h3>
                <p className="text-xs md:text-sm text-slate-600 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <section className="py-8 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-40 right-20 w-24 h-24 bg-white/5 rounded-lg animate-bounce transform rotate-45" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
          <div className="absolute bottom-40 right-10 w-20 h-20 bg-white/5 rounded-lg animate-bounce transform -rotate-12" style={{ animationDelay: '0.5s' }}></div>

          <div className="absolute top-1/4 left-1/4 animate-float">
            <Zap className="w-8 h-8 text-white/20" />
          </div>
          <div className="absolute top-1/3 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
            <Shield className="w-6 h-6 text-white/20" />
          </div>
          <div className="absolute bottom-1/3 left-1/3 animate-float" style={{ animationDelay: '3s' }}>
            <TrendingUp className="w-7 h-7 text-white/20" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          {/* Main Content */}

          <div className="space-y-4 animate-fadeInUp">
            <h2 className="text-2xl sm:text-3xl lg:text-3xl font-bold text-white leading-tight animate-slideInLeft">
              One Platform. Multiple Channels. Infinite Growth.
            </h2>
          </div>

          {/* CTA Button - Smaller and More Compact */}
          <div className="mt-6 animate-fadeInUp" style={{ animationDelay: '1.2s' }}>
            <button
              className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-white to-blue-50 text-blue-700 px-8 py-3 rounded-xl font-semibold text-lg hover:from-yellow-300 hover:to-orange-300 hover:text-gray-900 transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-yellow-300/50"
              onClick={() => {
                window.location.href = '/contact';
              }}
            >
              <Play className="w-5 h-5 group-hover:animate-bounce" />
              <span>Get In Touch</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />

              {/* Button Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </button>
          </div>
        </div>

        <style jsx>{`
             @keyframes float {
               0%, 100% { transform: translateY(0px) rotate(0deg); }
               33% { transform: translateY(-10px) rotate(5deg); }
               66% { transform: translateY(5px) rotate(-5deg); }
             }
             
             @keyframes fadeInUp {
               from { opacity: 0; transform: translateY(30px); }
               to { opacity: 1; transform: translateY(0); }
             }
             
             @keyframes slideInLeft {
               from { opacity: 0; transform: translateX(-50px); }
               to { opacity: 1; transform: translateX(0); }
             }
             
             @keyframes slideInRight {
               from { opacity: 0; transform: translateX(50px); }
               to { opacity: 1; transform: translateX(0); }
             }
             
             @keyframes slideInUp {
               from { opacity: 0; transform: translateY(40px); }
               to { opacity: 1; transform: translateY(0); }
             }
             
             .animate-float {
               animation: float 4s ease-in-out infinite;
             }
             
             .animate-fadeInUp {
               animation: fadeInUp 0.8s ease-out forwards;
               opacity: 0;
             }
             
             .animate-slideInLeft {
               animation: slideInLeft 0.8s ease-out forwards;
               opacity: 0;
             }
             
             .animate-slideInRight {
               animation: slideInRight 0.8s ease-out forwards;
               opacity: 0;
             }
             
             .animate-slideInUp {
               animation: slideInUp 0.8s ease-out forwards;
               opacity: 0;
             }
           `}</style>
      </section>
      <Footer />
    </div>
  );
}
export default PaymentSolutionsLanding;